// @ vendors
const { Promise } = require('es6-promise');
const get = require('lodash/object/get');
// @ actions
const notification = require('actions/notifications');
const signaturePatternActions = require('actions/signaturePattern');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatText, getLanguage } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
// @ utilities
const { recordProcess, PROC_HIRE_PROMOTIONS, PROC_CANCEL } = require('utilities/tagging');

const cancelHirePromotion = () => (dispatch) => {
    recordProcess(PROC_HIRE_PROMOTIONS, PROC_CANCEL);
    const message = formatText('promotions-toasterCancelHirePromotion');
    dispatch(notification.error({message}, {voice: message}));
};

const setHirePromotionInProgress = () => ({
    type: actionTypes.SET_HIRE_PROMOTION_REQUEST
});

const setHirePromotionFailure = (error) => ({
    type: actionTypes.SET_HIRE_PROMOTION_FAILURE,
    payload : {
        error
    }
});

const cancelPromotionalCode = () => ({
    type: actionTypes.PROMOTIONS_CANCEL_PROMOTIONAL_CODE
});

const setHirePromotionSuccess = (promotionalCode, response) => ({
    type: actionTypes.SET_HIRE_PROMOTION_SUCCESS,
    payload: {
        data: get(response, 'result', {}),
        promotionalCode
    }
});

const setHirePromotion = (dispatch, data, promotionalCode) => {
    const requestData = {
        query: data
    };

    return APIPost(dispatch, apiURLBuilder.getURL('setHirePromotion'), requestData)
        .then((response) => dispatch(setHirePromotionSuccess(promotionalCode, response)))
        .catch( response => dispatch(setHirePromotionFailure(response.error)));
};

// isFromHirePromotionView may use promo code or invitation code
const setPromotion = (promotionalCode, isFromHirePromotionView = false) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immPromotions = getState().promotions;
        const promotionProduct = immPromotions.getIn(['byId', promotionalCode, 'product']);
        const isSettingPromotion = immPromotions.get('isSettingPromotion');
        const application = __CONTACT_CENTER__ ? immPromotions.getIn(['byId', promotionalCode, 'app']) : '';
        const code = isFromHirePromotionView ? promotionalCode : immPromotions.getIn(['byId', promotionalCode, 'code']);

        if (!isSettingPromotion) {
            const data = {
                application,
                code,
                dataToken: dataToken,
                product: promotionProduct,
                busquedaPor: 'P' // @ hardcoded
            };

            dispatch(setHirePromotionInProgress());
            setHirePromotion(dispatch, data, promotionalCode);
        }
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const requestPromotionInProgress = () => ({
    type: actionTypes.FETCH_PROMOTION_REQUEST
});

const requestPromotionSuccess = (response, promotionalCode) => ({
    type: actionTypes.FETCH_PROMOTION_SUCCESS,
    payload : {
        data: get(response, 'promotionalCodes', []),
        promotionalCode,
    }
});

const requestPromotionFailure = (error) => ({
    type: actionTypes.FETCH_PROMOTION_FAILURE,
    payload : {
        error
    }
});

const requestPromotion = (promotionalCode) => (dispatch, getState) => {
    const immPromotions = getState().promotions;
    const isAlreadyFetching = immPromotions.get('isFetchingPromotion');

    if (!isAlreadyFetching) {
        dispatch(requestPromotionInProgress());
        const requestData = {
            code: promotionalCode, 
            language: getLanguage().toUpperCase(),
        }
        return APIGet(dispatch, apiURLBuilder.getURL('requestPromotion', requestData))
            .then((response) => {
                dispatch(requestPromotionSuccess(response, promotionalCode));
            })
            .catch((response) => dispatch(requestPromotionFailure(response.error)));
    }
};

module.exports = {
    cancelHirePromotion,
    requestPromotion,
    setPromotion,
    cancelPromotionalCode
};
